/* eslint-disable no-unused-vars */
const mainnet = {
  RPC: 'https://rpc-mainnet.kcc.network',
  chainId: 321,
  tikuContractAddress: '0xd4b52510719c594514ce7fed6cc876c03278ccf8',
  wkcs: {
    address: '0x4446fc4eb47f2f6586f9faab68b3498f86c07521',
    decimals: 18
  },
  usdc: {
    address: '0x980a5afef3d17ad98635f6c5aebcbaeded3c3430',
    decimals: 18
  },
  kuswapRouterAddress: "0xA58350d6dEE8441aa42754346860E3545cc83cdA",
  LSDBagContractAddress: ""
}

const testnet = {
  RPC: 'https://rpc-testnet.kcc.network',
  chainId: 322,
  tikuContractAddress: '0xda5afB72DE10ADB6c7EB2870C592f10358C1c14A',
  // KoffeeSwap WKCS, other dexes have other address
  wkcs: {
    address: "0xB296bAb2ED122a85977423b602DdF3527582A3DA",
    decimals: 18
  },
  kuswapRouterAddress: "0xc5f442007e08e3b13C9f95fA22F2a2B9369d7C8C",
  usdc: {
    address: "0xD6c7E27a598714c2226404Eb054e0c074C906Fc9",
    decimals: 18
  },
  LSDBagContractAddress: "0x14AeB9C88b98b11371e8426c018709E29C58e28c"
}

// switch between the mainnet and the testnet here
const network = testnet;

export default {
  ...network,
  koffeeRouterAddress: '0xc0fFee0000C824D24E0F280f1e4D21152625742b'
}
